/**
 * Size guide links inside the product description open the existing
 * Size Guide popup instead of navigating to /pages/size-guide.
 *
 * Scoped to the product description so the Information > Size Guide
 * menu link still navigates to the page as normal. Falls back to the
 * plain link if the popup isn't on the page.
 */
document.addEventListener('click', (event) => {
  const link = event.target.closest('.product-short-description a[href*="/pages/size-guide"]');
  if (!link) return;

  const opener = document.querySelector('.product__size-guide-opener button');
  if (!opener) return;

  event.preventDefault();
  opener.click();
});
